import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { CheckboxUniDriver } from '../Checkbox/Checkbox.uni.driver';

export interface TableListHeaderUniDriver extends BaseUniDriver {
  getColumnTextAt(columnIndex: number): Promise<string>;
  toggleColumnSortAt(index: number): Promise<void>;
  getCheckbox(): CheckboxUniDriver;
}
